import service from "@/utils/request";

// 创建机构科目
interface createSubjectData {
  title: string;
  status: number;
}
export const createSubject = (data: createSubjectData) => {
  return service({
    url: "/api/v1/subjects/create",
    method: "post",
    data,
  });
};
// 编辑机构科目标题
interface editSubjectTitleData {
  subject_id: number;
  title: string;
}
export const editSubjectTitle = (data: editSubjectTitleData) => {
  return service({
    url: "/api/v1/subjects/title/modify",
    method: "post",
    data,
  });
};
// 编辑机构科目状态
interface editSubjectStatusData {
  subject_id: number;
  status: number;
}
export const editSubjectStatus = (data: editSubjectStatusData) => {
  return service({
    url: "/api/v1/subjects/status/modify",
    method: "post",
    data,
  });
};
// 科目列表
interface subjectListData {
  page: number;
  page_size: number;
  title?: string;
  status?: number;
}
export const subjectList = (params: subjectListData) => {
  return service({
    url: "/api/v1/subjects/list",
    method: "get",
    params,
  });
};
// 科目列表（设置列表）
export const subjectSettingList = () => {
  return service({
    url: "/api/v1/subjects/setting/list",
    method: "get",
  });
};
// 科目删除
interface deleteSubjectData {
  subject_id: number;
}
export const deleteSubject = (data: deleteSubjectData) => {
  return service({
    url: "/api/v1/subjects/del",
    method: "post",
    data,
  });
};
